import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  questionHeader: {
    id: "questionbank.list.questionHeader",
    defaultMessage: "Question"
  },
  courseHeader: {
    id: "questionbank.list.courseHeader",
    defaultMessage: "Course"
  },
  subjectHeader: {
    id: "questionbank.list.subjectHeader",
    defaultMessage: "Subject"
  },
  tagsHeader: {
    id: "questionbank.list.tagsHeader",
    defaultMessage: "Tags"
  },
  stateHeader: {
    id: "questionbank.list.stateHeader",
    defaultMessage: "State"
  },
  typeHeader: {
    id: "questionbank.list.typeHeader",
    defaultMessage: "Type"
  },
  stageHeader: {
    id: "questionbank.list.stageHeader",
    defaultMessage: "Stage"
  },
  publishedTypography: {
    id: "questionbank.list.publishedTypography",
    defaultMessage: "Published"
  },
  inReviewTypography: {
    id: "questionbank.list.inReviewTypography",
    defaultMessage: "In Review"
  },
  cancelledTypography: {
    id: "questionbank.list.cancelledTypography",
    defaultMessage: "Cancelled"
  },
  draftTypography: {
    id: "questionbank.list.draftTypography",
    defaultMessage: "Draft"
  },
  difficultyHeader: {
    id: "questionbank.list.difficultyHeader",
    defaultMessage: "Difficulty"
  },
  noItemsFoundText: {
    id: "questionbank.list.noItemsFoundText",
    defaultMessage: "No items found"
  },
  noTagsTypography: {
    id: "questionbank.list.noTagsTypography",
    defaultMessage: "No tags"
  },
  editButton: {
    id: "questionbank.list.editButton",
    defaultMessage: "EDIT"
  },
  backButton: {
    id: "questionbank.list.backButton",
    defaultMessage: "BACK"
  }
});